<template>
  <div>
    <div>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card>
              <message :messages="messages"></message>
              <v-toolbar dense color="grey lighten-5" flat>
                <v-icon>mdi-format-align-justify</v-icon>
                <v-toolbar-title class="toolbar-title-3">{{ labels.listTitle }}</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-data-table
                        :headers="headers"
                        :items="items"
                        v-bind:options.sync="pagination"
                        :server-items-length="totalItems"
                        :loading="loading"
                        :footer-props="{'items-per-page-options': itemsPerPage }"
                        :no-data-text="noDataText"
                      >
                        <template v-slot:item="row"
                          ><tr>
                            <td>{{ row.item.itemNo }}</td>
                            <td>{{ row.item.siDesc1 }}</td>
                            <td>{{ formatNumber(row.item.si) }}</td>
                            <td class="table-action-header">
                              <table-action
                                :rowData="row"
                                :review="canReview(row)"
                                @review="doReview(row.item)"
                                :query="canQuery(row)"
                                @query="doQuery(row.item)"
                              ></table-action>
                            </td></tr
                        ></template>
                      </v-data-table>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <v-spacer class="mt-2"></v-spacer>
    <!-- Coverage Details -->
    <v-expansion-panels v-model="panel" multiple>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div>
            <v-icon>mdi-information-outline</v-icon><span class="headerTitle">{{ labels.coverageTitle }}</span>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card>
            <v-card-text>
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs6 md6 lg6>
                    <v-subheader class="queryLabel">{{ labels.itemNo }}</v-subheader>
                    <span class="queryValue">{{ form.itemNo }}</span>
                  </v-flex>
                  <v-flex xs6 md6 lg6 v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.si }}</v-subheader>
                    <span class="queryValue" v-if="items.length > 0">{{ propInfo.siCurr }} {{ formatNumber(form.si) }}</span>
                  </v-flex>
                  <v-flex xs6 md6 lg6 v-else>
                    <v-layout column wrap>
                      <v-subheader class="queryLabel">{{ labels.si }}</v-subheader>
                      <v-layout xs6 md6 lg6 row wrap>
                        <v-flex xs6 md6 lg6>
                          <v-autocomplete
                            :items="currencyList"
                            v-model="form.siCurr"
                            :label="labels.siCurr2"
                            item-text="label"
                            item-value="value"
                            data-vv-name="siCurr"
                            :data-vv-as="labels.siCurr2"
                            :error-messages="errors.collect('form.siCurr')"
                            :disabled="this.form.itemNo > 1"
                            clearable
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs5 md5 lg5>
                          <v-text-field
                            :label="labels.si2"
                            v-model="form.si"
                            :error-messages="errors.collect('si')"
                            data-vv-name="si"
                            :data-vv-as="labels.si2"
                            v-num-mask="{ negative: false, intScale: 18, decScale: 2 }"
                            v-validate="'mask_decimal:2|mask_min_value:0.00|mask_max_value:999999999999999999.99'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 md12 lg12>
                    <div class="subheading">{{ labels.siTitle }}</div>
                  </v-flex>
                  <v-flex xs6 md6 lg6 v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.siDesc1 }}</v-subheader>
                    <span class="queryValue">{{ form.siDesc1 }}</span>
                  </v-flex>
                  <v-flex xs6 md6 lg6 v-else>
                    <v-text-field
                      :label="labels.siDesc1"
                      v-model="form.siDesc1"
                      :error-messages="errors.collect('siDesc1')"
                      v-validate="'max:50'"
                      data-vv-name="siDesc1"
                      :data-vv-as="labels.siDesc1"
                    ></v-text-field>
                  </v-flex>
                  <!-- <v-flex xs6 md6 lg6 v-if="queryMode || propInfo.propType === 'FI'"> -->
                  <v-flex xs6 md6 lg6 v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.siDesc2 }}</v-subheader>
                    <span class="queryValue">{{ form.siDesc2 }}</span>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-else>
                    <v-text-field
                      :label="labels.siDesc2"
                      v-model="form.siDesc2"
                      :error-messages="errors.collect('siDesc2')"
                      v-validate="'max:50'"
                      data-vv-name="siDesc2"
                      :data-vv-as="labels.siDesc2"
                    ></v-text-field>
                  </v-flex>
                  <!-- <v-flex xs6 md6 lg6 v-if="queryMode || propInfo.propType === 'FI'"> -->
                  <v-flex xs6 md6 lg6 v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.siDesc3 }}</v-subheader>
                    <span class="queryValue">{{ form.siDesc3 }}</span>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-else>
                    <v-text-field
                      :label="labels.siDesc3"
                      v-model="form.siDesc3"
                      :error-messages="errors.collect('siDesc3')"
                      v-validate="'max:50'"
                      data-vv-name="siDesc3"
                      :data-vv-as="labels.siDesc3"
                    ></v-text-field>
                  </v-flex>
                  <!-- <v-flex xs6 md6 lg6 v-if="queryMode || propInfo.propType === 'FI'"> -->
                  <v-flex xs6 md6 lg6 v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.siDesc4 }}</v-subheader>
                    <span class="queryValue">{{ form.siDesc4 }}</span>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-else>
                    <v-text-field
                      :label="labels.siDesc4"
                      v-model="form.siDesc4"
                      :error-messages="errors.collect('siDesc4')"
                      v-validate="'max:50'"
                      data-vv-name="siDesc4"
                      :data-vv-as="labels.siDesc4"
                    ></v-text-field>
                  </v-flex>
                  <!-- <v-flex xs6 md6 lg6 v-if="queryMode || propInfo.propType === 'FI'"> -->
                  <v-flex xs6 md6 lg6 v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.siDesc5 }}</v-subheader>
                    <span class="queryValue">{{ form.siDesc5 }}</span>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-else>
                    <v-text-field
                      :label="labels.siDesc5"
                      v-model="form.siDesc5"
                      :error-messages="errors.collect('siDesc5')"
                      v-validate="'max:50'"
                      data-vv-name="siDesc5"
                      :data-vv-as="labels.siDesc5"
                    ></v-text-field>
                  </v-flex>
                  <!-- <v-flex xs6 md6 lg6 v-if="queryMode || propInfo.propType === 'FI'"> -->
                  <v-flex xs6 md6 lg6 v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.siDesc6 }}</v-subheader>
                    <span class="queryValue">{{ form.siDesc6 }}</span>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-else>
                    <v-text-field
                      :label="labels.siDesc6"
                      v-model="form.siDesc6"
                      :error-messages="errors.collect('siDesc6')"
                      v-validate="'max:50'"
                      data-vv-name="siDesc6"
                      :data-vv-as="labels.siDesc6"
                    ></v-text-field>
                  </v-flex>
                  <!-- <v-flex xs6 md6 lg6 v-if="queryMode || propInfo.propType === 'FI'"> -->
                  <v-flex xs6 md6 lg6 v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.siDesc7 }}</v-subheader>
                    <span class="queryValue">{{ form.siDesc7 }}</span>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-else>
                    <v-text-field
                      :label="labels.siDesc7"
                      v-model="form.siDesc7"
                      :error-messages="errors.collect('siDesc7')"
                      v-validate="'max:50'"
                      data-vv-name="siDesc7"
                      :data-vv-as="labels.siDesc7"
                    ></v-text-field>
                  </v-flex>
                  <!-- <v-flex xs6 md6 lg6 v-if="queryMode || propInfo.propType === 'FI'"> -->
                  <v-flex xs6 md6 lg6 v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.siDesc8 }}</v-subheader>
                    <span class="queryValue">{{ form.siDesc8 }}</span>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-else>
                    <v-text-field
                      :label="labels.siDesc8"
                      v-model="form.siDesc8"
                      :error-messages="errors.collect('siDesc8')"
                      v-validate="'max:50'"
                      data-vv-name="siDesc8"
                      :data-vv-as="labels.siDesc8"
                    ></v-text-field>
                  </v-flex>
                  <!-- <v-flex xs6 md6 lg6 v-if="queryMode || propInfo.propType === 'FI'"> -->
                  <v-flex xs6 md6 lg6 v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.siDesc9 }}</v-subheader>
                    <span class="queryValue">{{ form.siDesc9 }}</span>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-else>
                    <v-text-field
                      :label="labels.siDesc9"
                      v-model="form.siDesc9"
                      :error-messages="errors.collect('siDesc9')"
                      v-validate="'max:50'"
                      data-vv-name="siDesc9"
                      :data-vv-as="labels.siDesc9"
                    ></v-text-field>
                  </v-flex>
                  <!-- <v-flex xs6 md6 lg6 v-if="queryMode || propInfo.propType === 'FI'"> -->
                  <v-flex xs6 md6 lg6 v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.siDesc10 }}</v-subheader>
                    <span class="queryValue">{{ form.siDesc10 }}</span>
                  </v-flex>
                  <v-flex xs6 md4 lg4 v-else>
                    <v-text-field
                      :label="labels.siDesc10"
                      v-model="form.siDesc10"
                      :error-messages="errors.collect('siDesc10')"
                      v-validate="'max:50'"
                      data-vv-name="siDesc10"
                      :data-vv-as="labels.siDesc10"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md12 lg12>
                    <div class="subheading">{{ labels.excessTitle }}</div>
                  </v-flex>
                  <v-flex xs6 md6 lg6 v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.excess1 }}</v-subheader>
                    <span class="queryValue">{{ form.excess1 }}</span>
                  </v-flex>
                  <v-flex xs6 md6 lg6 v-else>
                    <v-text-field
                      :label="labels.excess1"
                      v-model="form.excess1"
                      :error-messages="errors.collect('excess1')"
                      v-validate="'max:50'"
                      data-vv-name="excess1"
                      :data-vv-as="labels.excess1"
                      :disabled="disableEdit"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md6 lg6 v-if="queryMode">
                    <v-subheader class="queryLabel">{{ labels.excess2 }}</v-subheader>
                    <span class="queryValue">{{ form.excess2 }}</span>
                  </v-flex>
                  <v-flex xs6 md6 lg6 v-else>
                    <v-text-field
                      :label="labels.excess2"
                      v-model="form.excess2"
                      :error-messages="errors.collect('excess2')"
                      v-validate="'max:50'"
                      data-vv-name="excess2"
                      :data-vv-as="labels.excess2"
                      :disabled="disableEdit"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
      <v-btn class="mt-2 mr-2" color="error" dark @click.prevent="doExit">
        {{ labels.exit }}
        <v-icon dark right>mdi-exit-to-app</v-icon>
      </v-btn>
      <v-btn v-if="reviewMode" color="primary" dark class="mt-2" @click="doSave" :loading="submitting">
        {{ labels.save }}
        <v-icon right>mdi-content-save</v-icon>
      </v-btn>
  </div>
</template>

<script>
import clone from 'clone'
import * as TableConst from '@/mixins/table'
import { listMixin } from '@/mixins/listMixin'
import { expandURI, filterQuery } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { formatDisplayNumber, removeFormatNumber } from '@/utils/number'
export default {
  data() {
    return {
      labels: {
        listTitle: 'Coverage List',
        coverageTitle: 'Coverage Details',
        exit: 'Exit',
        itemNo: 'Item No.',
        si: 'Sum Insured Amount',
        si2: 'Amount',
        siCurr: 'Sum Insured Currency',
        siCurr2: 'Currency',
        siTitle: 'Sum to Insured On',
        siDesc1: 'Description 1',
        siDesc2: 'Description 2',
        siDesc3: 'Description 3',
        siDesc4: 'Description 4',
        siDesc5: 'Description 5',
        siDesc6: 'Description 6',
        siDesc7: 'Description 7',
        siDesc8: 'Description 8',
        siDesc9: 'Description 9',
        siDesc10: 'Description 10',
        excessTitle: 'Excess',
        excess1: 'Excess 1',
        excess2: 'Excess 2',
        save: 'Save'
      },
      form: {
        propNo: null,
        ipcNo: null,
        ipcSeqNo: null,
        itemNo: null,
        si: 0,
        siDesc1: '',
        siDesc2: '',
        siDesc3: '',
        siDesc4: '',
        siDesc5: '',
        siDesc6: '',
        siDesc7: '',
        siDesc8: '',
        siDesc9: '',
        siDesc10: '',
        excess1: '',
        excess2: '',
        siCurr: ''
      },
      filters: {
        propNo: null,
        ipcNo: null,
        ipcSeqNo: null
      },
      headers: [
        { text: 'Item No.', value: 'itemNo' },
        { text: 'Sum to Insure On', value: 'siDesc1' },
        { text: 'Sum Insured', value: 'si' },
        TableConst.tableActionHeader
      ],
      items: [],
      totalItems: 0,
      currencyList: [],
      reviewMode: false,
      queryMode: false,
      loading: false,
      submitting: false,
      disableEdit: false,
      panel: [0],
      pagination: {
        sortDesc: [true],
        page: 1
      }
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  methods: {
    doInit(data) {
      this.fetchData()
      this.doQuery(data)
    },
    async fetchData(options) {
      let apiUrl = this.menu.getCoverageList
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          let massageFilters = clone(this.filters)
          if (massageFilters.propNo === null) {
            massageFilters.propNo = this.propInfo.propNo
          }
          if (massageFilters.ipcNo === null) {
            massageFilters.ipcNo = this.propInfo.ipcNo
          }
          if (massageFilters.ipcSeqNo === null) {
            massageFilters.ipcSeqNo = this.propInfo.ipcSeqNo
          }
          const result = await this.$http.get(
            filterQuery(expandURI(apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
          )
          if (result.data) {
            this.totalItems = result.data.totalItems
            const { data } = result.data
            if (data) {
              this.items = []
              data.map((coverage) => {
                const convertCoverage = {
                  propNo: coverage.propNo,
                  ipcNo: coverage.ipcNo,
                  ipcSeqNo: coverage.ipcSeqNo,
                  itemNo: coverage.itemNo,
                  si: coverage.si,
                  siDesc1: coverage.siDesc1,
                  siDesc2: coverage.siDesc2,
                  siDesc3: coverage.siDesc3,
                  siDesc4: coverage.siDesc4,
                  siDesc5: coverage.siDesc5,
                  siDesc6: coverage.siDesc6,
                  siDesc7: coverage.siDesc7,
                  siDesc8: coverage.siDesc8,
                  siDesc9: coverage.siDesc9,
                  siDesc10: coverage.siDesc10,
                  excess1: coverage.excess1,
                  excess2: coverage.excess2
                }
                this.items.push(convertCoverage)
              })
            } else {
              this.items = []
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doQuery(data) {
      this.resetMessages()
      this.resetFormData()
      this.loading = true
      const apiUrl = this.menu.getCoverageDetails
      if (apiUrl) {
        try {
          const expand = {
            propNo: data === undefined ? this.propInfo.propNo : data.propNo,
            ipcNo: data === undefined ? this.propInfo.ipcNo : data.ipcNo,
            ipcSeqNo: data === undefined ? this.propInfo.ipcSeqNo : data.ipcSeqNo,
            itemNo: data === undefined ? 1 : data.itemNo
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))

          if (result.data) {
            const { data } = result.data
            this.form.itemNo = data.coverDetails.itemNo
            this.form.si = data.coverDetails.si
            this.form.siDesc1 = data.coverDetails.siDesc1
            this.form.siDesc2 = data.coverDetails.siDesc2
            this.form.siDesc3 = data.coverDetails.siDesc3
            this.form.siDesc4 = data.coverDetails.siDesc4
            this.form.siDesc5 = data.coverDetails.siDesc5
            this.form.siDesc6 = data.coverDetails.siDesc6
            this.form.siDesc7 = data.coverDetails.siDesc7
            this.form.siDesc8 = data.coverDetails.siDesc8
            this.form.siDesc9 = data.coverDetails.siDesc9
            this.form.siDesc10 = data.coverDetails.siDesc10
            this.form.excess1 = data.coverDetails.excess1
            this.form.excess2 = data.coverDetails.excess2
            // this.form.siCurr = this.propInfo.siCurr
            // this.loading = false
          }
          this.loading = false
          // else {
          //   this.errorMessage('Invalid Fetch Result')
          //   this.loading = false
          // }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async getCurrencyList() {
      const apiURI = this.menu.getCurrencyList
      if (apiURI) {
        this.loading = true
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          this.currencyList = []
          if (data) {
            data.map((currency) => {
              const convertList = {
                value: currency.value,
                label: currency.label
              }
              this.currencyList.push(convertList)
            })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doReview(data) {
      this.form.itemNo = data.itemNo
      this.form.si = data.si
      this.form.siDesc1 = data.siDesc1
      this.form.siDesc2 = data.siDesc2
      this.form.siDesc3 = data.siDesc3
      this.form.siDesc4 = data.siDesc4
      this.form.siDesc5 = data.siDesc5
      this.form.siDesc6 = data.siDesc6
      this.form.siDesc7 = data.siDesc7
      this.form.siDesc8 = data.siDesc8
      this.form.siDesc9 = data.siDesc9
      this.form.siDesc10 = data.siDesc10
      this.form.excess1 = data.excess1
      this.form.excess2 = data.excess2
      // this.form.siCurr = this.propInfo.siCurr
      if (data.itemNo > 1) {
        this.disableEdit = true
      } else {
        this.disableEdit = false
      }
    },
    async doSave() {
      const apiURI = this.menu.savePropItem
      if (apiURI) {
        this.submitting = true
        try {
          let massageForm = clone(this.form)
          massageForm.propNo = this.propInfo.propNo
          massageForm.ipcNo = this.propInfo.ipcNo
          massageForm.ipcSeqNo = this.propInfo.ipcSeqNo
          massageForm.si = removeFormatNumber(this.form.si)
          const result = await this.$http.put(apiURI, massageForm)
          const { data } = result
          this.form.siCurr = data.siCurr
          if (data) {
            this.notify(data)
            this.doInit(data)
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    resetFormData() {
      this.form.itemNo = ''
      this.form.si = 0
      this.form.siDesc1 = ''
      this.form.siDesc2 = ''
      this.form.siDesc3 = ''
      this.form.siDesc4 = ''
      this.form.siDesc5 = ''
      this.form.siDesc6 = ''
      this.form.siDesc7 = ''
      this.form.siDesc8 = ''
      this.form.siDesc9 = ''
      this.form.siDesc10 = ''
      this.form.excess1 = ''
      this.form.excess2 = ''
    },
    doExit() {
      window.history.back()
    },
    doCancel() {
      this.$router.push({ name: 'propListing' })
    },
    canReview(data) {
      if (this.reviewMode) {
        return true
      } else {
        return false
      }
    },
    canQuery(data) {
      if (this.queryMode) {
        return true
      } else {
        return false
      }
    },
    formatDate(xDate) {
      if (xDate === null) {
        return undefined
      } else {
        return formatDisplayDate(xDate)
      }
    },
    formatNumber(xNum) {
      return formatDisplayNumber(xNum)
    }
  },
  computed: {
    propInfo() {
      return this.$store.state.proposal.proposalDetails.propInfo
    },
    propMode() {
      return this.$store.state.proposal.proposalMode
    },
    menu() {
      return this.$store.state.proposal.coverageDetails.menu
    }
  },
  beforeMount() {
    this.form.siCurr = this.propInfo.siCurr
    this.filters.propNo = this.propInfo.propNo
    this.filters.ipcNo = this.propInfo.ipcNo
    this.filters.ipcSeqNo = this.propInfo.ipcSeqNo
    this.doInit()
    if (this.propMode === 'Review') {
      this.reviewMode = true
      this.queryMode = false
      this.getCurrencyList()
    } else {
      this.reviewMode = false
      this.queryMode = true
    }
  },
  mixins: [TableConst.default, listMixin, MessageMixin]
}
</script>
